import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Stack,
} from "@mui/material";
import { GitHub, LinkedIn } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGitlab } from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from "react-i18next";
import HeaderData from "../data/HeaderData.json";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import SectionHeading from "../components/SectionHeading";

function ContactContainer() {
  const { t } = useTranslation();
  const { ref, visible } = useScrollAnimation();

  return (
    <Box
      id="contact"
      ref={ref}
      sx={{
        py: { xs: 4, md: 8 },
        px: { xs: 1, sm: 2 },
        scrollMarginTop: { xs: "56px", md: "64px" },
        opacity: visible ? 1 : 0,
        transform: visible ? "none" : "translateY(40px)",
        transition: "opacity 0.7s ease, transform 0.7s ease",
      }}
    >
      <SectionHeading tag="contact" title={t("contact.title")} number={5} />
      <Box sx={{ maxWidth: 560, mx: "auto", px: { xs: 1, sm: 0 } }}>
        <Card
          sx={{
            background:
              "linear-gradient(135deg, rgba(17,17,23,0.97) 0%, rgba(9,9,11,0.97) 100%)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(99,102,241,0.15)",
          }}
        >
          <CardContent sx={{ p: { xs: 2.5, sm: 3, md: 4 } }}>
            <Typography
              variant="body1"
              sx={{
                mb: { xs: 3, md: 4 },
                color: "text.secondary",
                textAlign: "center",
                fontSize: { xs: "0.95rem", sm: "1rem" },
                lineHeight: 1.8,
              }}
            >
              {t("contact.description")}
            </Typography>

            <Stack spacing={{ xs: 1.5, md: 2 }}>
              <Button
                component="a"
                href={HeaderData.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                size="large"
                startIcon={<LinkedIn />}
                sx={{
                  py: { xs: 1.5, md: 1.75 },
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                  background: "linear-gradient(135deg, #0077b5, #0099d6)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #005582, #0077b5)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 24px rgba(0,119,181,0.35)",
                  },
                  transition: "all 0.25s ease",
                }}
              >
                {t("contact.linkedin")}
              </Button>

              <Button
                component="a"
                href={HeaderData.github}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                size="large"
                startIcon={<GitHub />}
                sx={{
                  py: { xs: 1.5, md: 1.75 },
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                  background: "linear-gradient(135deg, #1f2328, #2d333b)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #0d1117, #1f2328)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
                  },
                  transition: "all 0.25s ease",
                }}
              >
                {t("contact.github")}
              </Button>

              <Button
                component="a"
                href={HeaderData.gitlab}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                size="large"
                startIcon={<FontAwesomeIcon icon={faGitlab} />}
                sx={{
                  py: { xs: 1.5, md: 1.75 },
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                  background: "linear-gradient(135deg, #e24329, #fc6d26)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #c1341a, #e24329)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 24px rgba(252,109,38,0.35)",
                  },
                  transition: "all 0.25s ease",
                }}
              >
                {t("contact.gitlab")}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default ContactContainer;
